var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import bs58 from 'bs58';
import { VersionedTransaction, SendTransactionError, } from '@solana/web3.js';
/**
 * Executes a Solana swap transaction.
 * @param connection - The Solana connection object.
 * @param signedTransaction - The signed transaction object.
 * @returns An object containing the transaction hash, explorer URL, and error message (if any).
 */
export function executeSolana(_a) {
    return __awaiter(this, arguments, Promise, function (_b) {
        var signedTransaction, rawTransaction, txid, simulateConfig, simulation, e_1, logs, logError_1, e_2;
        var connection = _b.connection, transactionString = _b.transactionString, _c = _b.awaitConfirmation, awaitConfirmation = _c === void 0 ? false : _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 12, , 13]);
                    console.log('Executing Order SOLANA Checking transaction signatures in executeSolana');
                    signedTransaction = VersionedTransaction.deserialize(bs58.decode(transactionString));
                    rawTransaction = signedTransaction.serialize();
                    txid = void 0;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, , 11]);
                    console.log('Executing Order SOLANA Sending raw transaction in executeSolana');
                    simulateConfig = {
                        sigVerify: true,
                        commitment: 'confirmed',
                    };
                    return [4 /*yield*/, connection.simulateTransaction(signedTransaction, simulateConfig)];
                case 2:
                    simulation = _d.sent();
                    console.log('Executing Order SOLANA Transaction simulation:', simulation);
                    if (simulation.value.err) {
                        throw new Error("Transaction simulation failed: ".concat(JSON.stringify(simulation, null, 2)));
                    }
                    return [4 /*yield*/, connection.sendRawTransaction(rawTransaction, {
                            skipPreflight: false,
                            maxRetries: 2,
                            preflightCommitment: 'processed',
                        })];
                case 3:
                    txid = _d.sent();
                    console.log('Executing Order SOLANA Transaction sent with ID:', txid);
                    return [3 /*break*/, 11];
                case 4:
                    e_1 = _d.sent();
                    if (!(e_1 instanceof SendTransactionError)) return [3 /*break*/, 9];
                    console.log(' Executing Order SOLANA SendTransactionError encountered:');
                    console.log(' Executing Order SOLANA Error message:', e_1.message);
                    _d.label = 5;
                case 5:
                    _d.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, e_1.getLogs()];
                case 6:
                    logs = _d.sent();
                    console.log(' Executing Order SOLANA Detailed error logs:', logs);
                    return [3 /*break*/, 8];
                case 7:
                    logError_1 = _d.sent();
                    console.log(' Executing Order SOLANA Error fetching logs:', logError_1);
                    return [3 /*break*/, 8];
                case 8:
                    console.log(' Executing Order SOLANA Error details:', e_1.message);
                    throw e_1;
                case 9:
                    console.log('Executing Order SOLANA Error sending raw transaction:', e_1.message);
                    throw e_1;
                case 10: return [3 /*break*/, 11];
                case 11: 
                // try {
                //   console.log('Confirming transaction:', txid);
                //   const confirmation = await connection.confirmTransaction(txid, 'processed');
                //   console.log('Transaction confirmed:', confirmation);
                // } catch (e) {
                //   console.log(' Executing Order SOLANA Error confirming transaction:', e);
                //   return {
                //     txHash: txid,
                //     explorerUrl: `https://solscan.io/tx/${txid}`,
                //     error: `Transaction sent but confirmation failed: ${
                //       e instanceof Error ? e.message : String(e)
                //     }`,
                //   };
                // }
                return [2 /*return*/, {
                        txHash: txid,
                        explorerUrl: "https://solscan.io/tx/".concat(txid),
                        error: null,
                    }];
                case 12:
                    e_2 = _d.sent();
                    console.log('Executing Order SOLANA Unexpected error in executeSolana:', e_2);
                    return [2 /*return*/, {
                            txHash: null,
                            explorerUrl: null,
                            error: e_2 instanceof Error ? e_2.message : String(e_2),
                        }];
                case 13: return [2 /*return*/];
            }
        });
    });
}
